import { SortableTableBody } from './SortableTableBody'
import { SortableTableRow } from './SortableTableRow'

export const SortableTable = {
    Row: SortableTableRow,
    Body: SortableTableBody,
}
